import { prefix } from './src/utils/constant'
import {
  mapObject
} from './src/utils'
import './common'

import layout from './src/components/layout/layout/'
import layoutV2 from './src/components/layout/layout-v2/'
import layoutV2Header from './src/components/layout/layout-v2/layout-v2-header'
import detailLayoutV1 from './src/components/layout/detail-layout-v1'
import leftRightLayout from './src/components/layout/left-right-layout'
import subTitle from './src/components/layout/sub-title'
import formTableLayout from './src/components/layout/form-table-layout'
import cardList from './src/components/layout/card-list/'
import cardListItem from './src/components/layout/card-list/card-list-item'

let components = {
  layout,
  layoutV2,
  layoutV2Header,
  detailLayoutV1,
  leftRightLayout,
  subTitle,
  formTableLayout,
  cardList,
  cardListItem
}

const install = Vue => {
  mapObject(components, component => {
    if (component.name) {
      Vue.component(prefix + component.name, component)
    } else {
      console.error('组件注册失败：缺少name')
    }
  })
}

export default {
  install
}
